<template>
  <div :class="$style['enter-amount-dialog']">
    <el-dialog :visible="dialogVisible" :title="(isEdit?'编辑':'录入') + '额度'" @close="cancel" >
      <pt-form-list-item label="事业部：" required>
        <wt-selector :options="organizationList" v-model="formValue.department" data-vv-as="事业部" name="name"
          v-validate="'required'"></wt-selector>
      </pt-form-list-item>
      <pt-form-list-item label="+/-：" :required="true">
        <wt-radio :radios="typeList" data-vv-as="操作类型" v-validate="'required'" v-model="formValue.operationType"></wt-radio>
      </pt-form-list-item>
      <pt-form-list-item label="额度：" :required="true">
        <wt-input :class="$style['number-input-price']" v-model="formValue.amount" data-vv-as="额度"
          v-validate="'required|decimal:2|morezero'">
          <el-button slot="append">¥</el-button>
        </wt-input>
      </pt-form-list-item>
      <pt-form-list-item label="内容/原因简述：" required>
        <wt-input v-model="formValue.content" v-validate="'required'" data-vv-as="内容/原因简述" placeholder="请输入20字以内...">
        </wt-input>
      </pt-form-list-item>
      <div :class="$style.button">
        <el-button type="primary" @click="submit" :loading="loading">确认</el-button>
        <el-button type="primary" plain @click="cancel">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { cashCount } from '@/utils/formUtils'
import formMixins from 'mixins/form'
export default {
  name: 'enter-amount-dialog',
  mixins: [formMixins],
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    departmentList: {
      type: Array,
      default: () => []
    },
    editAmount: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      typeList: [{
        label: '增加',
        value: 'INCREASE'
      },
      {
        label: '减少',
        value: 'DECREASE'
      }
      ],
      organizationList: [],
      formValue: {},
      loading: false
    }
  },
  watch: {
    editAmount: {
      handler (val) {
        if (this.isEdit && val) {
          this.changeEditAmount(val)
        }
      }
    },
    departmentList: {
      handler (val) {
        this.organizationList = val
      },
      deep: true
    },
    isEdit: {
      handler (val) {
        if (!this.isEdit) {
          this.formValue = {}
        } else {
          this.changeEditAmount(this.editAmount)
        }
      },
      deep: true
    }
  },
  methods: {
    changeEditAmount (data) {
      this.formValue = data
      this.formValue.amount = data.balance_show
    },
    cancel () {
      if (!this.isEdit) {
        this.formValue = {}
      } else {
        this.changeEditAmount(this.editAmount)
      }
      this.$emit('close', false)
    },
    submit () {
      this.validate().then(formValue => {
        let ajaxUrl = 'AddBalance'
        if (this.isEdit) {
          ajaxUrl = 'updateBalance'
        }
        let data = this.changFormValue(this.formValue)
        this.formValue = {}
        this.loading = true
        this.$store.dispatch(ajaxUrl, data).then(res => {
          this.loading = false
          this.$message.success((this.isEdit ? '编辑' : '录入') + `额度成功`)
          this.$emit('close', true)
        }).catch(err => {
          this.loading = false
          this.$message.error(err)
        })
      })
    },
    changFormValue (data) {
      data.amount = cashCount(data.amount)
      let department = JSON.parse(data.department)
      data.departmentId = department.id
      data.departmentName = department.name
      return data
    }
  }
}
</script>
<style module lang="less">
  .enter-amount-dialog {
    :global {
      .wt-input {
        width: 3rem
      }
      .el-dialog{
          padding: .3rem;
      }
    }
  }
  .button{
      margin-top: .3rem;
  }
</style>
